import navigationScripts from './navigation.js';
import newscripts from './main.js';


navigationScripts();
newscripts();

